<template>
    <GChart type="PieChart" class="pieChart" :data="chartData" :options="chartOptions"></GChart>
</template>

<script>
import { GChart } from "vue-google-charts/legacy";

export default {
    name: "PieChart",
    components: {
        GChart
    },
    props: ["pieData"],
    computed: {
        // noOfCorrectAttempt / noOfAttempt yields NaN when either count is missing
        // and Infinity when the denominator is 0. Either one renders as a broken
        // slice, so non-finite values are coerced to 0 before they reach the chart.
        chartData() {
            if (!Array.isArray(this.pieData)) return this.pieData;

            return this.pieData.map((row, rowIndex) => {
                // Row 0 is the header (["Type", "Percentage"]).
                if (rowIndex === 0 || !Array.isArray(row)) return row;

                return row.map((cell) =>
                    typeof cell === "number" && !Number.isFinite(cell) ? 0 : cell
                );
            });
        }
    },
    data() {
        return {
            // chartData: [
            //     ["Type", "Percentage"],
            //     ['Correct', 80],
            //     ['Incorrect', 20],
            // ],

            chartOptions: {
                title: 'Answering pattern of other users',
                colors: ["#BBD5F9", "#E7CCF6"],
                titleTextStyle: {
                    fontSize: 12
                },
                chartArea: {
                    height: '80%',
                    width: '80%'
                },
                    legend: {
                    position: 'bottom',
                    alignment: 'center',
                    textStyle: {
                        fontSize: 11,
                        color: '#666'
                    },
                    maxLines: 2
                },
            },
        }
    }
}
</script>

<style scoped>
.pieChart {
    height: 12.5rem;
    padding-bottom: 0.5rem;
}
</style>